import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=158ad0b4&scoped=true&"
import script from "./Cover.vue?vue&type=script&lang=ts&"
export * from "./Cover.vue?vue&type=script&lang=ts&"
import style0 from "./Cover.vue?vue&type=style&index=0&id=158ad0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ad0b4",
  null
  
)

export default component.exports